import axios from "@/services/axios";
import { getCurrentInstance, reactive } from "vue";
import { normalizePermissions, permissionGranted } from '@/utils/permissions';

// Escopo dos consumidores de cobranças; não escreve no estado global legado.
const consumidoresCobrancas = new Set([
  'ListarCobrancas', 'DetalharCobranca', 'MonitoramentoCobrancasJobs',
  'ListarLotesCobrancas', 'ListarPoliticasCobrancas',
  'DetalharPoliticaCobranca', 'FormularioPoliticaCobranca',
  'ListarConfiguracoesCobrancas', 'FormularioConfiguracaoCobranca'
]);

function useCobrancasPermissions() {
  const globalState = reactive({ userPermissions: [], permissionsLoaded: false });

  async function fetchPermissions() {
    try {
      const response = await axios.get('/auth/permissions');
      globalState.userPermissions = normalizePermissions(response.data?.permissions);
      globalState.permissionsLoaded = true;
    } catch (error) {
      console.error('Erro ao buscar permissões:', error);
      globalState.userPermissions = [];
      globalState.permissionsLoaded = true;
    }
  }

  function hasPermission(permission) {
    if (!globalState.permissionsLoaded) return true;
    return permissionGranted(globalState.userPermissions, permission);
  }

  return { fetchPermissions, hasPermission };
}

export function usePermissions() {
  const component = getCurrentInstance()?.type;
  if (consumidoresCobrancas.has(component?.name || component?.__name)) {
    return useCobrancasPermissions();
  }

  // Acessa o globalState via instancia, que foi injetado em app.config.globalProperties.$globalState
  const { proxy } = getCurrentInstance();
  const globalState = proxy.$globalState;

  async function fetchPermissions() {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `/auth/permissions`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      globalState.userPermissions = response.data.permissions;
      globalState.permissionsLoaded = true;
    } catch (error) {
      console.error("Erro ao buscar permissões:", error);
      globalState.permissionsLoaded = true;
    }
  }

  function hasPermission(permission) {
    if (!globalState.permissionsLoaded) {
      return true;
    }
    if (!globalState.userPermissions) {
      return false;
    }
    if (globalState.userPermissions.includes("administrador")) {
      return true;
    }
    return globalState.userPermissions.includes(permission);
  }

  return { fetchPermissions, hasPermission };
}
